import type { SlaTranslation } from './types';

export const slaUr: SlaTranslation = {
  badge: {
    dueIn: 'جواب {{time}} میں دینا ہے',
    dueSoon: 'جواب {{time}} میں دینا ہے',
    dueNow: 'جواب ابھی دینا ہے',
    overdue: '{{time}} کی تاخیر ہو چکی ہے',
    paused: 'جواب کا وقت رکا ہوا ہے',
    outsideHours: 'جواب کا وقت کاروباری اوقات کا انتظار کر رہا ہے',
    first_reply: 'پہلا جواب',
    next_reply: 'اگلا جواب',
    detail: '{{kind}} کا ہدف: {{target}}۔',
  },
  urgent: {
    title: 'فوری، کسی نے نہیں لی',
    count: '{{n}} فوری',
    more: '{{total}} میں سے {{shown}} دکھائی گئی ہیں۔ جن کی آخری حد قریب ہے وہ پہلے ہیں۔',
    claim: 'لیں',
    claimName: '{{name}} کے ساتھ گفتگو لیں',
    claimed: '{{name}} کے ساتھ گفتگو اب آپ کی ہے۔',
    waited: '{{time}} سے انتظار',
    reason: {
      customer_request: 'کسی انسان سے بات کرنا چاہی',
      ai_escalated: 'AI نے حوالے کر دی',
      ai_unavailable: 'AI جواب نہیں دے سکا',
      ai_blocked: 'AI کو جواب دینے سے روکا گیا',
      ai_limit: 'AI اپنی حد تک پہنچ گیا',
      staff_release: 'قطار میں واپس رکھی گئی',
      channel_ai_off: 'اس چینل پر AI جواب نہیں دیتا',
      sla_moved: 'منتقل کی گئی: کسی نے وقت پر جواب نہیں دیا',
      other: 'کسی انسان کا انتظار',
    },
  },
  lost: {
    staff: '{{name}} یہ گفتگو پہلے ہی لے چکے ہیں۔',
    ai: '{{name}} اب اس گفتگو کا جواب دے رہا ہے۔',
    external: 'Chatwoot میں کسی نے یہ گفتگو پہلے ہی لے لی ہے۔',
    none: 'کسی اور نے یہ گفتگو پہلے بدل دی۔ اب دکھایا جا رہا ہے کہ یہ کہاں ہے۔',
  },
  settings: {
    title: 'جواب کے وقت کے اہداف',
    description:
      'ترجیح کے لحاظ سے آپ کی ٹیم کو کتنی جلدی جواب دینا چاہیے۔ وقت صرف اوپر دیے گئے کاروباری اوقات میں گنا جاتا ہے، اور گفتگو اسنوز ہونے پر رک جاتا ہے۔',
    guide: 'جواب کے وقت کے اہداف کیسے کام کرتے ہیں',
    enabled: 'اس برانڈ کے لیے جواب کے وقت کے اہداف استعمال کریں',
    enabledHint:
      'انسان کا انتظار کرنے والی گفتگو دکھاتی ہے کہ جواب کب تک دینا ہے، اور تاخیر ہونے پر تاخیر والی قطار میں چلی جاتی ہے۔',
    priority: 'ترجیح',
    firstReply: 'پہلا جواب اتنے وقت میں',
    nextReply: 'اگلا جواب اتنے وقت میں',
    amount: '{{priority}} کے لیے {{column}}',
    unit: '{{column}} کی اکائی، {{priority}}',
    minutes: 'منٹ',
    hours: 'گھنٹے',
    empty: 'کوئی ہدف نہیں',
    noPriority: 'بغیر ترجیح والی گفتگو درمیانی ترجیح کے اہداف استعمال کرتی ہے۔',
    invalid:
      '{{priority}} کے لیے {{column}}: 1 منٹ سے 7 دن تک کا پورا عدد درج کریں، یا خالی چھوڑ دیں۔',
    save: 'اہداف محفوظ کریں',
    saved: '{{name}} کے لیے جواب کے وقت کے اہداف محفوظ ہو گئے۔',
    overdue: {
      title: 'جب کوئی گفتگو اپنے ہدف سے آگے نکل جائے',
      alertLeads: 'ٹیم لیڈز کو فوراً اطلاع دیں',
      alertLeadsHint:
        'جو لوگ گفتگو سونپ سکتے ہیں انہیں Studio میں پتا چلتا ہے۔ جو آن لائن نہیں انہیں ای میل ملتی ہے، ہر 15 منٹ میں زیادہ سے زیادہ ایک۔',
      move: 'کوئی جواب نہ دے تو اسے منتقل کریں',
      moveHint:
        'یہ قطار میں واپس جاتی ہے، یا آپ کی منتخب ٹیم میں، اور اگلے شخص کو پیش کی جاتی ہے۔ گاہک کو نہیں بتایا جاتا۔',
      after: 'اس کے بعد منتقل کریں',
      afterUnit: 'منتقل کرنے سے پہلے انتظار کی اکائی',
      afterHint: 'ہدف سے آگے نکلنے کے بعد، کام کے اوقات میں گنا جاتا ہے۔',
      moveTo: 'یہاں منتقل کریں',
      queue: 'قطار (اس کی ٹیم وہی رہتی ہے)',
      team: '{{name}} ٹیم',
      teamGone: 'ایک ٹیم جو اب گفتگو نہیں لیتی',
      invalidAfter: 'اس کے بعد منتقل کریں: 1 منٹ سے 7 دن تک کا پورا عدد لکھیں۔',
    },
    loading: 'جواب کے وقت کے اہداف لوڈ ہو رہے ہیں',
  },
  moved: 'قطار میں واپس: جواب کے وقت کے ہدف کے اندر کسی نے جواب نہیں دیا۔',
};
